let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("52td4")).then(() => parcelRequire('gUUmV'));